module.exports = __webpack_public_path__ + "static/media/scans_0020.0f04fbfb.jpg";